import { render, staticRenderFns } from "./PopupTemplate.vue?vue&type=template&id=6c6b62a6&scoped=true&"
import script from "./PopupTemplate.vue?vue&type=script&lang=js&"
export * from "./PopupTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PopupTemplate.vue?vue&type=style&index=0&id=6c6b62a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6b62a6",
  null
  
)

export default component.exports